import { isMouseEvent } from './utils/event-type.js';
import { usePointerEvent } from '../events/use-pointer-event.js';
import { AnimationType } from '../render/utils/types.js';
function createHoverEvent(visualElement, isActive, callback) {
  return function (event, info) {
    var _a;
    if (!isMouseEvent(event) || !visualElement.isHoverEventsEnabled) return;
    callback === null || callback === void 0 ? void 0 : callback(event, info);
    (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Hover, isActive);
  };
}
function useHoverGesture(_a, visualElement) {
  var onHoverStart = _a.onHoverStart,
    onHoverEnd = _a.onHoverEnd,
    whileHover = _a.whileHover;
  usePointerEvent(visualElement, "pointerenter", onHoverStart || whileHover ? createHoverEvent(visualElement, true, onHoverStart) : undefined);
  usePointerEvent(visualElement, "pointerleave", onHoverEnd || whileHover ? createHoverEvent(visualElement, false, onHoverEnd) : undefined);
}
export { useHoverGesture };